// src/components/ScrollToTopButton.js

import React, { useState, useEffect } from "react";
import "./styles.css"
const ScrollToTopButton = () => {
  // State quản lý việc hiển thị nút
  const [isVisible, setIsVisible] = useState(false);

  // Hàm cuộn lên đầu trang
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Cuộn mượt mà
    });
  };

  // Theo dõi sự kiện cuộn
  useEffect(() => {
    // Khoảng cách cuộn để nút bắt đầu hiển thị (ví dụ: 300px)
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    // Cleanup function (quan trọng để tránh rò rỉ bộ nhớ)
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []); // Chỉ chạy một lần khi component được mount

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-btn"
          aria-label="Cuộn lên đầu trang"
        >
          {}⬆
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
